export enum TYPEICON {
    ERROR='error',
    SUCCESS='success',
    WARNING='warning',
    INFO='info',
    QUESTION='question'
  }